import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, Validators, ValidationErrors, UntypedFormControl } from '@angular/forms';
import { VideoProviderValidators } from 'src/app/core/validators/video-provider.validators';
import { VideoProviderEdit } from '../model/video-provider';
import { merge } from 'lodash';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-video-provider-edit',
  templateUrl: './video-provider-edit.component.html',
  styleUrls: ['./video-provider-edit.component.scss']
})
export class VideoProviderEditComponent
{
  @Input() public isNew = false;

  @Output() public cancelling: EventEmitter<any> = new EventEmitter();
  @Output() public save: EventEmitter<VideoProviderEdit> = new EventEmitter();

  public editForm: any;
  public editFormActive = false;
  public urlPattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;

  private videoProviderEdit: VideoProviderEdit;

  constructor(
    private fb: UntypedFormBuilder,
    private videoProviderValidators: VideoProviderValidators)
  { }

  public get name(): UntypedFormControl
  {
    return this.editForm.get('name');
  }

  public get url(): UntypedFormControl
  {
    return this.editForm.get('url');
  }

  public get active(): UntypedFormControl
  {
    return this.editForm.get('active');
  }

  @Input() public set model(videoProvider: VideoProviderEdit)
  {
    this.initModel(videoProvider);
  }

  public onSave(e: Event): void
  {
    e.preventDefault();

    const objectToPersist = merge(this.videoProviderEdit, this.editForm.value);

    this.save.emit(objectToPersist);
    this.editFormActive = false;
  }

  public onCancel(e: Event): void
  {
    e.preventDefault();
    this.closeEditForm();
  }

  private closeEditForm(): void
  {
    this.editFormActive = false;
    this.cancelling.emit();
  }

  private initModel(videoProvider: VideoProviderEdit)
  {
    if (videoProvider === undefined)
    {
      return;
    }
    // Set the current video provider id used for name async validators
    const previousVideoProviderName = this.isNew ? '' : videoProvider.name;

    const urlValidators = [
      Validators.required,
      Validators.pattern(this.urlPattern)
    ];

    // Set form
    this.editForm = this.fb.group({
      id: [videoProvider.id],
      name: [
        { value: '', disabled: false },
        {
          validators: [Validators.required],
          asyncValidators: (): Observable<ValidationErrors | null> =>
            this.videoProviderValidators.validateVideoProviderNameUnique(this.editForm.get('name'), previousVideoProviderName)
        }
      ],
      active: { value: videoProvider.active, disabled: false },
      url: [
        { value: videoProvider.url, disabled: false },
        {
          validators: urlValidators
        }
      ]
    });

    this.videoProviderEdit = videoProvider;
    this.name.setValue(videoProvider.name);  // This is a work around to fix asyncValidators
    this.editFormActive = true;
  }
}
